export const fontPrimary = " proxima-nova, sans-serif"
export const fontHeading = "Brandon Printed, sans-serif"

